<template>
  <!-- Всего 4 типа плашек:
    info - серая
    warning - желтая
    error - красная
    success - зеленая
 -->
  <div :class="['alert', `alert--${type}`]">
    <Icon :iconName="iconName" :iconColor="iconColor || '#788694'" />
    <p v-html="text"></p>
    <a v-if="url" :href="url.value" target="_blank">{{
      url.lbl ? url.lbl : ''
    }}</a>
    <p v-if="buttonLabel" @click="$emit('buttonClick')" class="link">
      {{ buttonLabel }}
    </p>
  </div>
</template>
<script>
import Icon from 'Elements/Icon/Icon';
export default {
  props: {
    text: {
      type: String
    },
    type: {
      type: String,
      default: 'info'
    },
    url: {
      type: [String, Object],
      default: ''
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      if (this.type == 'info') {
        return 'CircleWarning';
      } else if (this.type == 'warning') {
        return 'Warning';
      } else if (this.type == 'error') {
        return 'error';
      } else if (this.type == 'success') {
        return 'success';
      } else {
        return 'CircleWarning';
      }
    }
  },
  components: { Icon }
};
</script>
<style lang="scss" scoped>
.alert {
  border-radius: 4px;
  width: 100%;
  display: flex;
  gap: 9px;
  padding: 12px 16px;

  p,
  a {
    font-weight: 400;
    font-size: 16px;
    text-align: left;
    line-height: 24px;
    text-decoration: unset;
    word-wrap: break-word;
  }

  a,
  .link {
    color: $blue64;
    cursor: pointer;
  }

  &--info {
    background: $grey8;
    color: $grey64;
  }

  &:not(.alert--info) {
    color: $grey80;
  }

  &--warning {
    background: $yellow16;
  }

  &--error {
    background: $red16;
  }

  &--success {
    background: $green16;
  }
}
</style>
